<template>
  <div>
    <div class="head">
      <img :src="baseUrl + headInfo.iconUrl" alt="">
      <p>{{ headInfo.title }}</p>
      <a class="banner_btn" @click="contactUs">{{ headInfo.remark }} &gt;</a>
    </div>
    <div class="current_menu">
      <div class="content">
        <ul>
          <li v-for="(item,index) in menuList" :key="index" :class="{'active': index === activeIndex }" @click="handleSelect(index)">{{ item.title }}</li>
        </ul>
        <a class="home" @click="goHome" />
      </div>
    </div>
    <div class="product current_content">
      <p class="current_title">产品</p>
      <ul>
        <li v-for="(item,index) in infoList" :key="'menu'+index">
          <div class="tag">
            <img :src="baseUrl + item.iconUrl" alt="">
            <span>{{ item.title }}</span>
          </div>
          <div class="link_list">
            <a
              v-for="(cItem,cIndex) in item.children"
              :key="'item'+cIndex"
              @click="productDetailSec(cItem)"
            >{{ cItem.title }}</a>
          </div>
        </li>
      </ul>
    </div>
    <div class="service current_content">
      <p class="current_title">服务</p>
      <div class="content">
        <div class="text">
          <p class="tips">秉着快速、优质、持续增值的服务宗旨，提供软件系统定制开发、托管､运维工作一体化服务。</p>
          <p class="large">售前咨询服务</p>
          <p class="small">根据企业的发展和管理需要，提供管理咨询及解决方案，帮助企业做出快速、准确的决策。</p>
          <p class="large">产品培训服务</p>
          <p class="small">在提供优秀产品的同时，不断推出配套的培训服务，帮助用户在应用软件时达到事半功倍的效果。</p>
          <p class="large">实施咨询服务</p>
          <p class="small">针对企业个性化的需求，提供“量身定制”服务。</p>
          <p class="large">个性化服务</p>
          <p class="small">结合国内外先进的管理理念和即时通信软件的实施方法，推出符合中国国情的标准软件实施方法，帮助客户有计划、有步骤、循序渐进的完成实施工作。</p>
          <p class="large">持续改进服务</p>
          <p class="small">项目成功实施后，根据用户的业务发展需要，不断为用户提供业务改进、系统增强等服务！</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { contactUs, goHome } from '@/plugin/operate.js'
import { getMainContent } from '@/plugin/api'

export default {
  data() {
    return {
      activeIndex: 0,
      infoList: [],
      headInfo: {},
      baseUrl: '/website',
      menuList: [
        {
          title: '产品',
          id: 0
        },
        {
          title: '服务',
          id: 1
        }
      ]
    }
  },
  mounted() {
    const params = this.$route.query
    params.tenantId = 'sft'
    this.getInfoList(params)
  },
  methods: {
    contactUs,
    goHome,
    handleSelect(key) {
      const pro = document.getElementsByClassName('product')[0].offsetTop
      const ser = document.getElementsByClassName('service')[0].offsetTop
      switch (key) {
        case 0:
          window.scrollTo({
            top: pro - 120,
            behavior: 'smooth'
          })
          break
        case 1:
          window.scrollTo({
            top: ser - 120,
            behavior: 'smooth'
          })
          break
      }
    },
    productDetail(item) {
      this.$router.push({
        query: {
          id: item.id
        }
      })
    },
    productDetailSec(item) {
      this.$router.push({
        path: '/productDetailSec',
        query: {
          url: item.url,
          urlType: item.urlType
        }
      })
    },
    getInfoList(params) {
      getMainContent(params).then(res => {
        const arr = res.data.data.contentMainList[0].contentItemTreeList
        this.headInfo = arr[0]
        const infoArr = arr.filter((item) => {
          return item.title === '产品'
        })
        this.infoList = infoArr[0].children
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.head{
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img{
    position: absolute;
    z-index: -1;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 100%;
  }
  p{
    color: #fff;
    font-size: 40px;
    font-weight: 600;
    margin-bottom: 20px;
  }
}
.product{
  width: 1170px;
  ul{
    display: flex;
    flex-wrap: wrap;
    li{
      height: 580px;
      margin-right: 15px;
      margin-bottom: 20px;
      padding: 20px 40px;
      box-shadow: 0px 2px 6px 0px rgba(204, 204, 204, 40);
      background-repeat: no-repeat;
      background-size: cover;
      &:nth-child(1){
        background-image: url('../assets/images/product/service_li1.jpg');
      }
      &:nth-child(2){
        background-image: url('../assets/images/product/service_li2.jpg');
      }
      &:nth-child(3){
        background-image: url('../assets/images/product/service_li3.jpg');
      }
      &:nth-child(4){
        background-image: url('../assets/images/product/service_li4.jpg');
      }
      &:nth-child(5){
        background-image: url('../assets/images/product/service_li5.jpg');
      }
      &:nth-child(6){
        background-image: url('../assets/images/product/service_li6.jpg');
      }
      &:nth-child(7){
        background-image: url('../assets/images/product/service_li7.jpg');
      }
      &:nth-child(8){
        background-image: url('../assets/images/product/service_li8.jpg');
      }
      .tag{
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        color: #101010;
        font-size: 18px;
        font-weight: 600;
        img{
          margin-right: 10px;
        }
      }
      .link_list{
        width: 200px;
        text-align: left;
        a{
          display: block;
          cursor: pointer;
          color: #101010;
          margin: 15px 0;
        }
      }
      &:nth-child(4n){
        margin-right: 0;
      }

    }
  }
}
.service{
  text-align: center;
  .content{
    background-image: url('../assets/images/product/service_bg.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
  }
  .text{
    text-align: left;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    .tips{
      margin-bottom: 30px;
    }
    .large{
      margin-bottom: 5px;
    }
    .small{
      font-size: 14px;
      margin-bottom: 15px;
    }
  }
}
</style>
